
export const Bio = {
  name: "Kiruthiga Krishna Moorthy",
  roles: [
    "Backend Developer",
    "Python Enthusiast",
    "SQL Expert",
    "Aspiring Data Analyst"
  ],
  description:
    "I am a motivated and versatile backend developer, eager to take on new challenges and deliver high-quality results. With a positive attitude and a growth mindset, I'm committed to contributing meaningfully, learning continuously, and achieving great things with my team.",
  github: "https://github.com/kiruthiga-krishnamoorthy",
  resume: "https://drive.google.com/file/d/1B5R-vb5OWJIFixJdXOWXakbx6RNe6jgb/view?usp=drivesdk",
  linkedin: "https://www.linkedin.com/in/kiruthiga-krishna-moorthy",
  Email: "kiruthigamoorthy2006@gmail.com"
};

export const skills = [
  {
    title: "Backend",
    skills: [
      {
        name: "Python",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg"
      },
      {
        name: "Django",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg"
      },
      {
        name: "REST APIs",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg"
      }
    ]
  },
  {
    title: "Database",
    skills: [
      {
        name: "MySQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg"
      },
      {
        name: "SQLite",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg"
      }
    ]
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Machine Learning",
        image: "https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg"
      }
    ]
  },
  {
    title: "Other Tools",
    skills: [
      {
        name: "MS Excel",
        image: "https://upload.wikimedia.org/wikipedia/commons/7/73/Microsoft_Excel_2013-2019_logo.svg"
      },
      {
        name: "Power BI",
        image: "https://upload.wikimedia.org/wikipedia/commons/c/cf/New_Power_BI_Logo.svg"
      },
      {
        name: "Git",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg"
      }
    ]
  }
];
export const education = [
  {
    school: "Live Wire",
    degree: "Masters in Data Science",
    year: "2024-2025",
    desc: "Completed specialized coursework in Data Science and Machine Learning."
  },
  {
    school: "Shree Sakthi Kailash Women's College",
    degree: "Masters in Commerce",
    grade: "75%",
    year: "2022-2024",
    desc: "Focused on core commerce subjects and financial management."
    
  },
  {
    school: "Vivekananda Arts and Science College",
    degree: "Bachelors in Commerce",
    grade: "80%",
    year: "2019-2022",
    desc: ""
    
  }
];


export const projects = [
  {
    title: "Banking Management System",
    description: "Developed a full-fledged banking management system using Django, MySQL, REST APIs, and Power BI integration. Implemented secure user authentication, balance checking, deposits, withdrawals, mobile recharge, PIN reset, and integrated Google Text-to-Speech (gTTS) for voice interactions.",
    link: "https://github.com/kiruthiga-krishnamoorthy/banking-management-system"
  },
  {
    title: "Personal Expenses Tracker",
    description: "Built a personal expense tracker application to help users record, categorize, and analyze their daily expenses. Features include adding transactions, viewing monthly summaries, and generating visual reports using Python, SQLite, and Django REST framework.",
    link: "https://github.com/kiruthiga-krishnamoorthy/personal-expenses-tracker"
  },
  {
    title: "Zomato Backend Clone Simulation",
    description: "Created a backend simulation of Zomato using Django and REST APIs. Implemented restaurant listings, menu management, cart and order functionality, user authentication, and role-based access control to demonstrate backend design and API integration skills.",
    link: "https://github.com/kiruthiga-krishnamoorthy/zomato-backend-clone"
  }
];

